// Computes dynamic crew status from signupStatus + signOnDate/signOffDate vs today.
// Priority: INVITED/RE-INVITE → 'invited', non-ACTIVE → 'pending', date logic → 'onboard'/'onLeave'
import moment from 'moment';
import { resolveCrewDates } from './resolve-crew-dates';

// Crew dates arrive as DD-MM-YYYY (top-level) or YYYY/MM/DD (metadata fallback).
// new Date() can't parse DD-MM-YYYY, so parse explicitly with moment.
const parseCrewDate = (value) => {
  if (!value) return null;
  const m = moment(value, ['DD-MM-YYYY', 'YYYY/MM/DD']);
  return m.isValid() ? m.toDate() : null;
};

export const CREW_STATUS = {
  INVITED: 'invited',
  PENDING: 'pending',
  ONBOARD: 'onboard',
  ON_LEAVE: 'onLeave',
  SICK_LEAVE: 'sickLeave',
};

export function computeCrewStatus(member) {
  const { signupStatus, crewStatus } = member || {};
  const { signOnDate, signOffDate } = resolveCrewDates(member);

  // Account-level: haven't accepted invitation yet
  if (['INVITED', 'RE-INVITE'].includes(signupStatus)) return CREW_STATUS.INVITED;

  // Non-active accounts (UN-ASSIGNED, BOUNCED, unknown)
  if (signupStatus !== 'ACTIVE') return CREW_STATUS.PENDING;

  // Sick leave via crewStatus field
  if (crewStatus && crewStatus.toLowerCase().includes('sick')) return CREW_STATUS.SICK_LEAVE;

  // ACTIVE members: date-based dynamic status
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const on = parseCrewDate(signOnDate);
  if (on) on.setHours(0, 0, 0, 0);

  const off = parseCrewDate(signOffDate);
  if (off) off.setHours(0, 0, 0, 0);

  // Onboard: signOnDate <= today AND (no signOffDate OR signOffDate >= today)
  if (on && on <= today && (!off || off >= today)) return CREW_STATUS.ONBOARD;

  // Everything else: On Leave
  return CREW_STATUS.ON_LEAVE;
}
